import { createGlobalStyle } from 'styled-components';
import { rem } from 'polished';
import screen from 'superior-mq';
import { bp, hover } from 'Styles/helpers';

const GlobalStyle = createGlobalStyle`

  :root {
    --anchor-hover-color: ${props => props.theme.black};

    --routing-page-offset: -${props => props.routingPageOffset}px;

    --container: 1440px;

    ${screen.below(bp.desktop, `
      --container: 1200px;
    `)}

    ${screen.below(bp.laptopSm, `
      --container: 1000px;
    `)}

    ${screen.below(bp.tablet, `
      --container: 840px;
    `)}

    ${screen.below(bp.portrait, `
      --container: 660px;
    `)}
  }

  *,
  *::before,
  *::after { box-sizing: border-box; }

  body {
    margin: 0;
    font-family: ${props => props.theme.sansFont};
    font-size: ${rem(20)};
    font-weight: 400;
    line-height: 1.7;
    color: ${props => props.theme.black};

    ${screen.below(bp.portrait, `
      font-size: ${rem(18)};
    `)}

    ${screen.below(bp.portrait, `
      font-size: ${rem(15)};
    `)}
  }

  html {
    scroll-behavior: smooth;
  }

  main {
    position: relative;
    z-index: 1;
    opacity: 1;

    &:first-of-type:not(:only-of-type) {
      position: absolute;
      z-index: -1;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      opacity: 0;
    }

    &:last-of-type:not(:only-of-type) {
      transform: translateY(var(--routing-page-offset));
      position: relative;
      display: block;
    }
  }

  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    margin: 0;
    font-family: ${props => props.theme.condensedFont};
    font-weight: 400;
    line-height: .92;
    color: inherit;
  }

  h1,
  h2 {
    font-size: ${rem(130)};

    ${screen.below(bp.laptop, `
      font-size: ${rem(80)};
    `)}

    ${screen.below(bp.mobile, `
      font-size: ${rem(65)};
    `)}

    ${screen.below(bp.mobileRealSm, `
      font-size: ${rem(48)};
    `)}
  }

  h3 {
    font-size: ${rem(54)};
    line-height: 1;

    ${screen.below(bp.laptop, `
      font-size: ${rem(42)};
    `)}

    ${screen.below(bp.mobile, `
      font-size: ${rem(28)};
    `)}
  }

  h4 {
    font-size: ${rem(30)};
    line-height: 1.5;

    ${screen.below(bp.mobile, `
      font-size: ${rem(18)};
    `)}
  }

  h5 {
    font-size: ${rem(14)};
  }

  h6 {
    font-size: ${rem(12)};
  }

  a,
  button {
    cursor: pointer;
  }

  a {
    color: ${props => props.theme.blue};
    text-decoration: underline;
    transition: color .3s ease;

    ${hover(`
      color: var(--anchor-hover-color);
    `)}
  }

  img { max-width: 100%; }

  figure { margin: 0; }

  form { position: relative; }

  .js-stagger {
    opacity: 0;
  }
`;

export default GlobalStyle;
